// import React from 'react';
// import { Route, Switch, Redirect } from "react-router-dom";
// import { connect } from "react-redux";
// import { setCurrentUser } from "../../redux/user/user.actions";

// function AuthenticatedRoute({ component: C, appProps,isAuth, ...rest }) {
//     return (
//       <Route
//         {...rest}
//         render={props =>
//           isAuth
//             ? <C {...props} {...appProps} />
//             : <Redirect
//                 to={`/login?redirect=${props.location.pathname}${props.location.search}`}
//               />}
//       />
//     );
// }

// const mapStateToProps = (state) => ({
//     currentUser: state.user.currentUser,
//     isAuth: state.user.isAuth,
//   });
//   const mapDispatchToProps = (dispatch) => ({
//     setCurrentUser: (user) => dispatch(setCurrentUser(user)),
//   });
//   export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedRoute);

// import React from "react";
// import { Route, Redirect } from "react-router-dom";

// export default function SafeRoute({ component: Component, ...rest }) {
//   const token = localStorage.getItem("token");
//   const isGuest = localStorage.getItem("is_guest");

//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         token || isGuest ? (
//           <Component {...props} />
//         ) : (
//           <Redirect to="/login" />
//         )
//       }
//     />
//   );
// }

import React, { useState } from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import GuestSignupDialog from "../GuestSignupDialog";
import { isGuestUser, isGuestPathAllowed } from "../../utils/guestAccess";

// Shown when a guest lands on a screen they cannot use — the centered
// signup popup, then back to the DocTags tool screen on close.
function GuestBlockedScreen() {
  const [open, setOpen] = useState(true);
  const history = useHistory();

  const handleClose = () => {
    setOpen(false);
    history.replace("/docTags");
  };

  return (
    <div style={{ minHeight: "100vh", background: "#F8FAFF" }}>
      <GuestSignupDialog open={open} variant="signup" onClose={handleClose} />
    </div>
  );
}

export default function SafeRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        const token = sessionStorage.getItem("token");
        const isGuest = sessionStorage.getItem("is_guest") === "true";

        console.log("🛡️ SafeRoute Check:", {
          path: props.location.pathname,
          token,
          isGuest,
        });

        if (token || isGuest) {
          // Guests may only reach the DocTags screen and the three free
          // tools; every other protected screen shows the signup popup.
          if (
            isGuestUser() &&
            !isGuestPathAllowed(props.location.pathname)
          ) {
            console.log("🔒 Guest blocked:", props.location.pathname);
            return <GuestBlockedScreen />;
          }
          console.log("✅ Allowed:", props.location.pathname);
          return <Component {...props} />;
        }

        console.log("❌ Redirecting to login from:",props.location.pathname);
        return <Redirect to="/login" />;
      }}
    />
  );
}
